import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { QueryComponent } from 'GraphQL';
import { queryMyMockExamOverview } from 'GraphQL/query/MockExam.query';

import NoResultView from '../../Components/NoResultView';

import OverviewView from './Overview';

class Overview extends Component {
  static propTypes = {
    subjectName: PropTypes.string,
    subjectCode: PropTypes.string,
    examCardId: PropTypes.string,
    examId: PropTypes.string,
    relatedExam: PropTypes.object,
  };

  render() {
    const {
      subjectName,
      subjectCode,
      examCardId,
      examId,
      relatedExam = {},
      ...restProps
    } = this.props;
    const { officialHistory = [] } = relatedExam;
    return (
      <QueryComponent
        query={queryMyMockExamOverview}
        variables={{ examCardId, mockExamId: examId }}
      >
        {data => {
          const { myMockExamResult, mockExamResult } = data;
          if (!myMockExamResult) return <NoResultView />;
          return (
            <OverviewView
              mockExamId={examId}
              subjectName={subjectName}
              subjectCode={subjectCode}
              myMockExamResult={myMockExamResult}
              mockExamResult={mockExamResult}
              officialHistory={officialHistory}
              {...restProps}
            />
          );
        }}
      </QueryComponent>
    );
  }
}

export default Overview;
